import firebase from "firebase/app";

import 'firebase/analytics'
import 'firebase/auth'
import 'firebase/firestore'

var firebaseConfig = {
      apiKey: "AIzaSyAcSTPvYuwsMrKYO4j5Xep9MjA8AfB-WHM",
      authDomain: "chat-app-2-fd0e2.firebaseapp.com",
      projectId: "chat-app-2-fd0e2",
      storageBucket: "chat-app-2-fd0e2.appspot.com",
      messagingSenderId: "281054568314",
      appId: "1:281054568314:web:0c17a2f586cadcfa0600c3"
    };

// var firebaseConfig = {
//       apiKey: "AIzaSyAJFniHg-2k4OFeZba67rLbPalZivjRfJQ",
//       authDomain: "chat-app-f1c7f.firebaseapp.com",
//       projectId: "chat-app-f1c7f",
//       storageBucket: "chat-app-f1c7f.appspot.com",
//       messagingSenderId: "223029983206",
//       appId: "1:223029983206:web:c1236ca68cf5b355d40827",
//       measurementId: "G-SS0643P1SH"
// };
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();

const auth = firebase.auth();
const db = firebase.firestore();

//auth.useEmulator('http://localhost:9099');
if(window.location.hostname === 'localhost'){
      //db.useEmulator('localhost','8080');
}

export {auth, db};
export default firebase;